// Legende Items für Kalender-Kategorien (alphabetisch sortiert)
export const legendItems = [
    { id: 1, color: "#8e44ad", label: "Angela" },
    { id: 2, color: "#26a65b", label: "Feiertag" },
    { id: 3, color: "#f39c12", label: "Geburtstag" },
    { id: 4, color: "#e74c3c", label: "Gemeinsam" },
    { id: 5, color: "#007215ff", label: "Norbert" },
    { id: 6, color: "#2c3e50", label: "Schichtdienst" },
    { id: 7, color: "#3498db", label: "Schulferien" },
    { id: 8, color: "#d35400", label: "Urlaub" },
];

// Offizielle Schulferien für Sachsen 2024-2027
export const ferienZeitraeume = [    
    //2026
    { start: "2026-02-09", end: "2026-02-21", name: "Winterferien 2026" },
    { start: "2026-04-03", end: "2026-04-10", name: "Osterferien 2026" },
    { start: "2026-05-15", end: "2026-05-18", name: "Pfingstferien 2026" },
    { start: "2026-06-27", end: "2026-08-07", name: "Sommerferien 2026" },
    { start: "2026-10-12", end: "2026-10-24", name: "Herbstferien 2026" },
    { start: "2026-12-23", end: "2027-01-02", name: "Weihnachtsferien 2026/27" },
    // 2027
    { start: "2027-02-15", end: "2027-02-27", name: "Winterferien 2027" },
    { start: "2027-03-26", end: "2027-04-02", name: "Osterferien 2027" },
    { start: "2027-05-07", end: "2027-05-10", name: "Pfingstferien 2027" },
    { start: "2027-06-26", end: "2027-08-06", name: "Sommerferien 2027" },
    { start: "2027-10-11", end: "2027-10-23", name: "Herbstferien 2027" },
    { start: "2027-12-23", end: "2028-01-02", name: "Weihnachtsferien 2027/28" },
];
